import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestFeedbackDemo from './TestFeedbackDemo'
import TestFeedbackEditorActions from './TestFeedbackEditorActions'
import TestFeedbackElement from './TestFeedbackElement'
import TestFeedbackFormBrand from './TestFeedbackFormBrand'
import { STYLE_FORM_SCHEMA } from './TestFeedbackFormStyle'
import TestFeedbackFormValue from './TestFeedbackFormValue'
import icon from './assets/testFeedback.svg'

export default genElementConfig(CONFIG_ELEMENTS.testFeedback, {
  label: t('elements.testFeedback.label'),
  icon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestFeedbackElement,
  Demo: [TestFeedbackDemo],
  FormValue: TestFeedbackFormValue,
  FormBrand: TestFeedbackFormBrand,
  EditorActions: TestFeedbackEditorActions,
})
